'use client';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { DefaultXRController } from '@react-three/xr';
import { XrControllerHud } from './XrBindings.js';
/** Right grip is reserved for a future deliberate grab binding, so the library grab pointer stays off. */
export default function SpaceCanvasXrRightController() {
    return _jsxs(_Fragment, { children: [_jsx(DefaultXRController, { grabPointer: false }), _jsx(XrControllerHud, { hand: "right" })] });
}
